import React, { useState, useEffect } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, resolvePath } from "react-router-dom";
import { config } from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import GeneralDialogFooter from '../shared/GeneralDialogFooter';
import FaDate from '../shared/FaDate';
import PresentAbsentSave from './PresentAbsentSave';
import { Col, Container, Form, Row } from 'react-bootstrap';
import SelectTimeIndexes from './SelectTimeIndexes';
import ShowAbsentStudentList from './ShowAbsentStudentList';
import ShowVideo from '../shared/ShowVideo';


export default function SchoolAbsentPresent(props) {
  const [errorVisible, setErorVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [deleting, setDeleting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [presentAbsentFormVisible, setPresentAbsentFormVisible] = useState(false);
  const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);
  const [currentTimeId, setCurrentTimeId] = useState("");
  const [currentTimeIndex, setCurrentTimeIndex] = useState(-1);
  const [date, setDate] = useState(0);
  const [newDate, setNewDate] = useState(0);
  const [weekDayName, setWeekDayName] = useState("");
  const [deleteItemIds, setDeleteItemIds] = useState([]);
  const [selectTimeIndexesVisible, setSelectTimeIndexesVisible] = useState(false);
  const [showUnleagalAbsentStudentVisible, setShowUnleagalAbsentStudentVisible] = useState(false);
  const [timeIndexes, setTimeIndexes] = useState([true, false, false, false, false, false]);

  const [timings, setTimings] = useState([]);
  const [dayParts, setDayParts] = useState([]);

  useEffect(() => {
    loadData(0);
  }, []);
  const loadData = function (date) {
    setLoading(true);
    var params = { login: util.getTrustedUser(), date: date };
    var url = config.Server + `/school/day/timing/list`;
    console.log("params is>", params);
    console.log("url is>", url);
    axios
      .post(url, params)
      .then(res => {
        var response = res.data;
        if (response.state === "ok") {
          response = response.data;
          var dp = [
            { index: 0, title: "زنگ اول", presentSum: 0, legalAbsentSum: 0, unLegalAbsentSum: 0 },
            { index: 1, title: "زنگ دوم", presentSum: 0, legalAbsentSum: 0, unLegalAbsentSum: 0 },
            { index: 2, title: "زنگ سوم", presentSum: 0, legalAbsentSum: 0, unLegalAbsentSum: 0 },
            { index: 3, title: "زنگ چهارم", presentSum: 0, legalAbsentSum: 0, unLegalAbsentSum: 0 },
            { index: 4, title: "زنگ پنجم", presentSum: 0, legalAbsentSum: 0, unLegalAbsentSum: 0 },
            { index: 5, title: "زنگ ششم", presentSum: 0, legalAbsentSum: 0, unLegalAbsentSum: 0 },
          ];

          setDate(response.runClassDate);
          setWeekDayName(response.weekDayName);
          setNewDate(response.runClassDate);
          var items = response.schoolClasses;

          for (var j = 0; j < 6; j++) {
            dp[j].presentSum = 0;
            dp[j].legalAbsentSum = 0;
            dp[j].unLegalAbsentSum = 0;
          }
          for (var i = 0; i < items.length; i++) {
            var row = items[i];
            for (var j = 0; j < row.states.length; j++) {
              var state = row.states[j];
              if ((state.timeId1 != "") && (state.isDone1)) {
                dp[state.timeIndex].presentSum += state.present1;
                dp[state.timeIndex].legalAbsentSum += state.legalAbsent1;
                dp[state.timeIndex].unLegalAbsentSum += state.unLegalAbsent1;
              }
              if ((state.timeId2 != "") && (state.isDone2)) {
                dp[state.timeIndex].presentSum += state.present2;
                dp[state.timeIndex].legalAbsentSum += state.legalAbsent2;
                dp[state.timeIndex].unLegalAbsentSum += state.unLegalAbsent2;
              }
            }
          }

          setDayParts(dp);
          setTimings(items);

          setLoading(false);

        }
        else {
          setErrorMessage(response.message);
          setErorVisible(true);
          setLoading(false);
        }
      })
      .catch(error => {
        setErrorMessage(error.code + "," + error.message);
        setErorVisible(true);
        setLoading(false);
      });
  }

  const saveItem = function () {
  }
  const btnDeleteByIdClicked = function (timeId) {
    setDeleteItemIds([timeId]);
    setConfirmDeleteVisible(true);
  }
  const btnDeleteByClassClicked = function (schoolClassId) {
    var ids = [];
    for (var i = 0; i < timings.length; i++) {
      var row = timings[i];
      if (row.schoolClass.id != schoolClassId) continue;

      for (var j = 0; j < row.states.length; j++) {
        var state = row.states[j];
        if ((state.timeId1 != "") && (state.isDone1)) {
          ids.push(state.timeId1);
        }
        if ((state.timeId2 != "") && (state.isDone2)) {
          ids.push(state.timeId2);
        }
      }
    }
    console.log("selected ids is>", ids)
    setDeleteItemIds(ids);
    setConfirmDeleteVisible(true);
  }
  const btnDeleteByTimeIndexClicked = function (timeIndex) {
    var ids = [];
    for (var i = 0; i < timings.length; i++) {
      var row = timings[i];
      for (var j = 0; j < row.states.length; j++) {
        var state = row.states[j];
        if (state.timeIndex != timeIndex) continue;
        if ((state.timeId1 != "") && (state.isDone1)) {
          ids.push(state.timeId1);
        }
        if ((state.timeId2 != "") && (state.isDone2)) {
          ids.push(state.timeId2);
        }
      }
    }

    console.log("selected ids is>", ids)
    setDeleteItemIds(ids);
    setConfirmDeleteVisible(true);
  }
  const onDeleteConfirm_Accept = function () {
    deleteItem();
  }
  const onDeleteConfirm_Reject = function () {
    if (deleting) return;
    setConfirmDeleteVisible(false);
  }
  const deleteItem = function () {
    setDeleting(true);
    var params = { login: util.getTrustedUser(), runClassDate: date, timingIds: deleteItemIds };
    var url = config.Server + `/school/present-absent/delete`;
    axios
      .post(url, params)
      .then(res => {
        var response = res.data;
        if (response.state === "ok") {
          var tmp = [...timings];
          for (var i = 0; i < timings.length; i++) {
            var row = timings[i];
            for (var j = 0; j < row.states.length; j++) {
              var state = row.states[j];
              if (deleteItemIds.includes(state.timeId1)) {
                tmp[i].states[j].isDone1 = false;
                tmp[i].states[j].present1 = 0;
                tmp[i].states[j].legalAbsent1 = 0;
                tmp[i].states[j].unLegalAbsent1 = 0;
              }
              else if (deleteItemIds.includes(state.timeId2)) {
                tmp[i].states[j].isDone2 = false;
                tmp[i].states[j].present2 = 0;
                tmp[i].states[j].legalAbsent2 = 0;
                tmp[i].states[j].unLegalAbsent2 = 0;
              }
            }
          }
          setTimings(tmp);


          var dp = [...dayParts];
          for (var j = 0; j < 6; j++) {
            dp[j].presentSum = 0;
            dp[j].legalAbsentSum = 0;
            dp[j].unLegalAbsentSum = 0;
          }
          var items = tmp;
          for (var i = 0; i < items.length; i++) {
            var row = items[i];
            for (var j = 0; j < row.states.length; j++) {
              var state = row.states[j];
              if ((state.timeId1 != "") && (state.isDone1)) {
                dp[state.timeIndex].presentSum += state.present1;
                dp[state.timeIndex].legalAbsentSum += state.legalAbsent1;
                dp[state.timeIndex].unLegalAbsentSum += state.unLegalAbsent1;
              }
              if ((state.timeId2 != "") && (state.isDone2)) {
                dp[state.timeIndex].presentSum += state.present2;
                dp[state.timeIndex].legalAbsentSum += state.legalAbsent2;
                dp[state.timeIndex].unLegalAbsentSum += state.unLegalAbsent2;
              }
            }
          }

          setDayParts(dp);

          setDeleting(false);
          setConfirmDeleteVisible(false);
        }
        else {
          setErrorMessage(response.message);
          setErorVisible(true);
          setDeleting(false);
        }
      })
      .catch(error => {
        setDeleting(false);
        setErrorMessage(error.code + "," + error.message);
        setErorVisible(true);
      });

  }


  const onPresentAbsentChanged = function (timingId, presentCo, legalAbsentCo, unLegalAbsentCo) {
    var tmp = [...timings];
    for (var i = 0; i < timings.length; i++) {
      var row = timings[i];
      for (var j = 0; j < row.states.length; j++) {
        var state = row.states[j];
        if (state.timeId1 == timingId) {
          tmp[i].states[j].isDone1 = true;
          tmp[i].states[j].present1 = presentCo;
          tmp[i].states[j].legalAbsent1 = legalAbsentCo;
          tmp[i].states[j].unLegalAbsent1 = unLegalAbsentCo;
        }
        else if (state.timeId2 == timingId) {
          tmp[i].states[j].isDone2 = true;
          tmp[i].states[j].present2 = presentCo;
          tmp[i].states[j].legalAbsent2 = legalAbsentCo;
          tmp[i].states[j].unLegalAbsent2 = unLegalAbsentCo;
        }
      }
    }

    var dp = [...dayParts];
    for (var j = 0; j < 6; j++) {
      dp[j].presentSum = 0;
      dp[j].legalAbsentSum = 0;
      dp[j].unLegalAbsentSum = 0;
    }
    var items = tmp;
    for (var i = 0; i < items.length; i++) {
      var row = items[i];
      for (var j = 0; j < row.states.length; j++) {
        var state = row.states[j];
        if ((state.timeId1 != "") && (state.isDone1)) {
          dp[state.timeIndex].presentSum += state.present1;
          dp[state.timeIndex].legalAbsentSum += state.legalAbsent1;
          dp[state.timeIndex].unLegalAbsentSum += state.unLegalAbsent1;
        }
        if ((state.timeId2 != "") && (state.isDone2)) {
          dp[state.timeIndex].presentSum += state.present2;
          dp[state.timeIndex].legalAbsentSum += state.legalAbsent2;
          dp[state.timeIndex].unLegalAbsentSum += state.unLegalAbsent2;
        }
      }
    }

    setDayParts(dp);

    setTimings(tmp);
  }
  const showPresentAbsentForm = function (timeId, timeIndex) {
    setCurrentTimeId(timeId);
    setCurrentTimeIndex(timeIndex);
    setPresentAbsentFormVisible(true);
  }
  const closePresentAbsentForm = function () {
    setPresentAbsentFormVisible(false);
  }
  const createSimpleButton = function (timeId, timeIndex) {
    return (
      <div onClick={() => showPresentAbsentForm(timeId, timeIndex)} style={{ border: "1px solid #076d26ff", backgroundColor: "#82df8d", color: "#000000", position: "absolute", top: "5px", right: "5px", width: "20px", height: "12px", cursor: "pointer" }}>
        <div style={{ backgroundColor: "#8f8e8eff", position: "absolute", top: "4px", left: "3px", width: "2px", height: "2px" }}></div>
        <div style={{ backgroundColor: "#8f8e8eff", position: "absolute", top: "4px", left: "7px", width: "2px", height: "2px" }}></div>
        <div style={{ backgroundColor: "#8f8e8eff", position: "absolute", top: "4px", left: "11px", width: "2px", height: "2px" }}></div>
      </div>
    );
  }
  const createSimpleDeleteButton1 = function (timeId) {
    return (
      <div onClick={() => btnDeleteByIdClicked(timeId)} style={{ border: "1px solid #d60404ff", backgroundColor: "#9e4040ff", color: "#ffffff", position: "absolute", top: "5px", right: "30px", width: "20px", height: "12px", cursor: "pointer", textAlign: "center" }}>
        <div style={{ position: "absolute", top: "-6px", right: "5px", padding: "0px" }}>&times;</div>
      </div>
    );
  }
  const createSimpleDeleteButton2 = function (schoolClassId) {
    return (
      <div onClick={() => btnDeleteByClassClicked(schoolClassId)} style={{ border: "1px solid #d60404ff", backgroundColor: "#9e4040ff", color: "#ffffff", position: "absolute", bottom: "5px", right: "5px", width: "20px", height: "12px", cursor: "pointer", textAlign: "center" }}>
        <div style={{ position: "absolute", bottom: "-6px", right: "5px", padding: "0px" }}>&times;</div>
      </div>
    );
  }
  const createSimpleDeleteButton3 = function (timeIndex) {
    return (
      <div onClick={() => btnDeleteByTimeIndexClicked(timeIndex)} style={{ border: "1px solid #d60404ff", backgroundColor: "#9e4040ff", color: "#ffffff", position: "absolute", bottom: "5px", right: "5px", width: "20px", height: "12px", cursor: "pointer", textAlign: "center" }}>
        <div style={{ position: "absolute", bottom: "-6px", right: "5px", padding: "0px" }}>&times;</div>
      </div>
    );
  }
  return (
    <div>
      <ShowVideo videoId="present_absent" top={65} md={6} /> 
      {
        loading ?
          <>loading...</>
          :
          <>
            <Row>
              <Col md={3} style={{ marginTop: "10px", paddingTop: "5px" }}>
                <table>
                  <tbody>
                    <tr>
                      <td style={{ width: "70px" }}>تاریخ : </td>
                      <td style={{ width: "140px" }}><FaDate value={date} onChange={(val) => setNewDate(val)} /></td>
                      <td style={{ width: "80px" }}>{weekDayName}</td>
                    </tr>
                  </tbody>
                </table>
              </Col>
              <Col md={2} style={{ marginTop: "10px", maxWidth: "200px" }}>
                <div className="card flex justify-content-center" style={{ direction: "ltr", textAlign: "right" }}>
                  <Button disabled={newDate <= 0} label="مشاهده" icon="pi pi-check" onClick={() => { loadData(newDate) }} severity="success" iconPos="right" loading={loading} />
                </div>
              </Col>
            </Row>
            <Container fluid>
              <Row style={{ overflow: "scroll", marginTop: "10px" }}>
                <table border="1" style={{ borderCollapse: 'collapse', width: '100%' }}>
                  <thead>
                    <tr>
                      <th style={{ textAlign: "center", width: "70px", padding: "5PX", border: "1px solid #b0b0b0" }}>کلاس</th>
                      {
                        dayParts.map((zang) => {
                          return (
                            <th style={{ textAlign: "center", backgroundColor: "#808080", color: "#fff", padding: "10px 5px", position: "relative" }}>
                              {zang.title}
                              {createSimpleDeleteButton3(zang.index)}
                            </th>
                          )
                        })
                      }
                    </tr>
                  </thead>
                  <tbody>
                    {timings.map((row) =>
                      <tr>
                        <td style={{ textAlign: "center", padding: "5PX", position: "relative", border: "1px solid #b0b0b0" }}>
                          {row.schoolClass.name}
                          {createSimpleDeleteButton2(row.schoolClass.id)}
                        </td>
                        {
                          row.states.map((state) => {
                            return (
                              <td style={{ textAlign: "center", padding: "5PX", border: "1px solid #b0b0b0" }}>
                                {
                                  (state.timeId1 != "") ?
                                    <div style={{ minWidth: "190px", backgroundColor: ((state.isDone1) ? "#daf7e3ff" : "#f7dbc5ff"), height: "68px", position: "relative", margin: "3px", width: "calc(100% - 3px)", padding: "3px", borderRadius: "5px", border: "1px solid #b0b0b0" }}>
                                      {createSimpleButton(state.timeId1, state.timeIndex)}
                                      {createSimpleDeleteButton1(state.timeId1)}
                                      <div title={state.teacher1.firstname + " " + state.teacher1.lastname + " - " + state.course1.name} style={{ position: "absolute", right: "55px", top: "2px", width: "calc(100% - 65px)", height: "22px", overflow: "hidden", textAlign: "right", fontSize: "8pt" }}>
                                        {state.teacher1.firstname + " " + state.teacher1.lastname} - {state.course1.name}
                                      </div>
                                      <table style={{ borderCollapse: "collapse", position: "absolute", right: "5px", top: "20px", width: "calc(100% - 30px)" }}>
                                        <tbody>
                                          <tr>
                                            <td style={{ fontSize: "8pt", border: "1px solid #b0b0b0", textAlign: "center" }}>حاضر</td>
                                            <td style={{ fontSize: "8pt", border: "1px solid #b0b0b0", textAlign: "center" }}>غ موجه</td>
                                            <td style={{ fontSize: "8pt", border: "1px solid #b0b0b0", textAlign: "center" }}>غ غیرموجه</td>
                                          </tr>
                                          <tr>
                                            <td style={{ fontSize: "8pt", border: "1px solid #b0b0b0", textAlign: "center" }}>{state.present1}</td>
                                            <td style={{ fontSize: "8pt", border: "1px solid #b0b0b0", textAlign: "center" }}>{state.legalAbsent1}</td>
                                            <td style={{ fontSize: "8pt", border: "1px solid #b0b0b0", textAlign: "center" }}>{state.unLegalAbsent1}</td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                    :
                                    <></>
                                }
                                {
                                  (state.timeId2 != "") ?
                                    <div style={{ minWidth: "190px", backgroundColor: ((state.isDone2) ? "#daf7e3ff" : "#f7dbc5ff"), height: "68px", position: "relative", margin: "3px", width: "calc(100% - 3px)", padding: "3px", borderRadius: "5px", border: "1px solid #b0b0b0" }}>
                                      {createSimpleButton(state.timeId2, state.timeIndex)}
                                      <div title={state.teacher2.firstname + " " + state.teacher2.lastname + " - " + state.course2.name} style={{ position: "absolute", right: "45px", top: "2px", width: "calc(100% - 35px)", height: "22px", overflow: "hidden", textAlign: "right", fontSize: "8pt" }}>
                                        {state.teacher2.firstname + " " + state.teacher2.lastname} - {state.course2.name}
                                      </div>
                                      <table style={{ borderCollapse: "collapse", position: "absolute", right: "5px", top: "20px", width: "calc(100% - 30px)" }}>
                                        <tbody>
                                          <tr>
                                            <td style={{ fontSize: "8pt", border: "1px solid #b0b0b0", textAlign: "center" }}>حاضر</td>
                                            <td style={{ fontSize: "8pt", border: "1px solid #b0b0b0", textAlign: "center" }}>غ موجه</td>
                                            <td style={{ fontSize: "8pt", border: "1px solid #b0b0b0", textAlign: "center" }}>غ غیرموجه</td>
                                          </tr>
                                          <tr>
                                            <td style={{ fontSize: "8pt", border: "1px solid #b0b0b0", textAlign: "center" }}>{state.present2}</td>
                                            <td style={{ fontSize: "8pt", border: "1px solid #b0b0b0", textAlign: "center" }}>{state.legalAbsent2}</td>
                                            <td style={{ fontSize: "8pt", border: "1px solid #b0b0b0", textAlign: "center" }}>{state.unLegalAbsent2}</td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                    :
                                    <></>
                                }
                                {
                                  ((state.timeId1 == "") && (state.timeId2 == "")) ?
                                    <>&nbsp;</>
                                    :
                                    <></>
                                }
                              </td>
                            )
                          })
                        }
                      </tr>)}
                    <tr style={{ height: "70px" }}>
                      <td style={{ textAlign: "center", width: "70px", padding: "5PX" }}>جمع کل</td>
                      {
                        dayParts.map((zang) => {
                          return (
                            <td style={{ textAlign: "center", backgroundColor: "#f8f8f8", color: "#000", padding: "5px", position: "relative" }}>
                              <table style={{ borderCollapse: "collapse", position: "absolute", right: "10px", top: "10px", width: "calc(100% - 40px)" }}>
                                <tbody>
                                  <tr>
                                    <td style={{ fontSize: "8pt", border: "1px solid #b0b0b0", textAlign: "center" }}>حاضر</td>
                                    <td style={{ fontSize: "8pt", border: "1px solid #b0b0b0", textAlign: "center" }}>غ موجه</td>
                                    <td style={{ fontSize: "8pt", border: "1px solid #b0b0b0", textAlign: "center" }}>غ غیرموجه</td>
                                  </tr>
                                  <tr>
                                    <td style={{ fontSize: "8pt", border: "1px solid #b0b0b0", textAlign: "center" }}>{zang.presentSum}</td>
                                    <td style={{ fontSize: "8pt", border: "1px solid #b0b0b0", textAlign: "center" }}>{zang.legalAbsentSum}</td>
                                    <td style={{ fontSize: "8pt", border: "1px solid #b0b0b0", textAlign: "center" }}>{zang.unLegalAbsentSum}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          )
                        })
                      }
                    </tr>

                  </tbody>
                </table>
              </Row>
              <Row>
                <Col md={4} style={{ marginTop: "10px" }}>
                  <div className="card flex justify-content-center" style={{ direction: "ltr", textAlign: "right" }}>
                    <Button label="مشاهده لیست غایبین غیر موجه" icon="pi pi-search" onClick={() => setSelectTimeIndexesVisible(true)} severity="success" iconPos="right" />
                  </div>
                </Col>
              </Row>
              <Row><Col>&nbsp;</Col></Row>
              <Row><Col>&nbsp;</Col></Row>
              <Row><Col>&nbsp;</Col></Row>
              <Row><Col>&nbsp;</Col></Row>
            </Container>
          </>
      }
      {
        presentAbsentFormVisible ?
          <PresentAbsentSave hideLegalAbsent={false} timingId={currentTimeId} runClassDate={date} timeIndex={currentTimeIndex} weekDayName={weekDayName} onChange={(timingId, presentCo, legalAbsentCo, unLegalAbsentCo) => { onPresentAbsentChanged(timingId, presentCo, legalAbsentCo, unLegalAbsentCo) }} onClose={() => closePresentAbsentForm()} />
          :
          <></>
      }
      {
        selectTimeIndexesVisible ?
          <SelectTimeIndexes onClose={() => { setSelectTimeIndexesVisible(false); }} onChange={(times) => { setTimeIndexes(times); setSelectTimeIndexesVisible(false); setShowUnleagalAbsentStudentVisible(true); }} />
          :
          <></>
      }
      {
        showUnleagalAbsentStudentVisible ?
          <ShowAbsentStudentList onSend={(co, create) => { setShowUnleagalAbsentStudentVisible(false); setErorVisible(true); setErrorMessage(co + " مورد پیامک "+(create?"ایجاد":"ارسال")+" گردید") }} timeIndexes={timeIndexes} runClassDate={date} onClose={() => { setShowUnleagalAbsentStudentVisible(false) }} />
          :
          <></>
      }

      <ShowError visible={errorVisible} message={errorMessage} closeError={() => { setErorVisible(false) }} />
      <ShowConfirm visible={confirmDeleteVisible} message="آیا از حذف مطمئن هستید؟" caption="اطمینان از حذف" onAccept={onDeleteConfirm_Accept} onReject={onDeleteConfirm_Reject} loading={deleting} />
    </div>
  );
}
